module.exports = __webpack_public_path__ + "static/media/Nick.2349f68a.png";